"use client";

import { useT } from "@/Hooks";
import { InfoSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import HomeOneInfoSectionGenerated, {
  HomeOneInfoSectionGeneratedProps,
} from "../Sections/_generated/HomeOneInfoSection.generated";
import { buildGeneratedSectionProps } from "./generated-section-renderer";

const GeneratedInfoSection: FC<InfoSectionProps> = (props) => {
  const t = useT();
  const defaults =
    buildGeneratedSectionProps<HomeOneInfoSectionGeneratedProps>(
      "HomeOneInfoSection",
    );
  const primaryPhone = props.pageData.CommonData.Tels?.[0];
  const email = props.pageData.CommonData.Email;
  const defaultItems = defaults.infoSectionConInfos ?? [];

  return (
    <HomeOneInfoSectionGenerated
      {...defaults}
      sectionDiv0Div0Div0Div0H30H3Text={
        props.setting.Title ?? defaults.sectionDiv0Div0Div0Div0H30H3Text
      }
      infoSectionConInfos={[
        {
          ...(defaultItems[0] ?? {}),
          key: "phone",
          p0Text: t("common.field.mobile", undefined, "Mobile"),
          p1Text: primaryPhone ?? defaultItems[0]?.p1Text ?? "",
          className: defaultItems[0]?.className ?? "isax isax-headphone5",
        },
        {
          ...(defaultItems[1] ?? {}),
          key: "email",
          p0Text: t("common.field.email", undefined, "Email"),
          p1Text: email ?? defaultItems[1]?.p1Text ?? "",
          className: defaultItems[1]?.className ?? "isax isax-message-25",
        },
      ]}
    />
  );
};

export default GeneratedInfoSection;
